import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { TrackingEffects } from './effects/tracking.effects';

@NgModule({
  imports: [EffectsModule.forFeature([TrackingEffects])],
})
export class RioTrackingStoreModule {}
